import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  activityConnectRouteRef,
  controlPlaneActivityNewRouteRef,
  controlPlaneConnectRouteRef,
  controlPlaneCockpitRouteRef,
  activityDetailRouteRef,
  activityMetricsRouteRef,
  activityNewRouteRef,
  controlPlaneNewRouteRef,
  rootRouteRef,
} from './routes';
import { spassuCodeApiRef, SpassuCodeClient } from './api';
import {
  frontierCockpitApiRef,
  FrontierCockpitClient,
} from './cockpit/FrontierCockpitApi';

export const spassuCodePlugin = createPlugin({
  id: 'spassu-code',
  routes: {
    root: rootRouteRef,
    activityNew: activityNewRouteRef,
    controlPlaneActivityNew: controlPlaneActivityNewRouteRef,
    activityConnect: activityConnectRouteRef,
    activityDetail: activityDetailRouteRef,
    activityMetrics: activityMetricsRouteRef,
  },
  externalRoutes: {
    controlPlaneNew: controlPlaneNewRouteRef,
    controlPlaneConnect: controlPlaneConnectRouteRef,
    controlPlaneCockpit: controlPlaneCockpitRouteRef,
  },
  apis: [
    createApiFactory({
      api: spassuCodeApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new SpassuCodeClient(discoveryApi, fetchApi),
    }),
    createApiFactory({
      api: frontierCockpitApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new FrontierCockpitClient(discoveryApi, fetchApi),
    }),
  ],
});

export const SpassuCodePage = spassuCodePlugin.provide(
  createRoutableExtension({
    name: 'SpassuCodePage',
    component: () =>
      import('./components/SpassuCodePage').then(m => m.SpassuCodePage),
    mountPoint: rootRouteRef,
  }),
);
